import React from "react";
import { motion } from "framer-motion";

function About(){
return(

<section className="py-20 text-center dark:text-white" id="about"  >

<motion.div
initial={{opacity:0, y:50}}
whileInView={{opacity:1, y:0}}
transition={{duration:0.6}}
>

<h2 className="text-4xl font-bold mb-6 dark:text-white">About Me</h2>

<p className="max-w-3xl mx-auto text-lg text-gray-700 dark:text-white">
Hello, I am <strong>Vyankatesh Gadge</strong>, a web developer skilled in 
React.js, Node.js, SQL, Supabase, JavaScript, Python and Django. I build modern and responsive applications.
</p>

<p className="mt-6 text-gray-600 dark:text-white">
📧 Email: vyankateshgadge8@gmail.com
</p>

</motion.div>

</section>

);
}

export default About;